'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _analytics;

exports.default = reducer;
exports.openCustomizeTripPopup = openCustomizeTripPopup;
exports.openEvening = openEvening;
exports.setField = setField;
exports.logCustomizeTrip = logCustomizeTrip;
exports.submit = submit;
exports.getCustomizeTrips = getCustomizeTrips;
exports.getDisplayTrips = getDisplayTrips;
exports.customizeQty = customizeQty;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_CUSTOMIZE_TRIP = 'redux-frontend/customize/REQUEST_CUSTOMIZE_TRIP';
var REQUEST_CUSTOMIZE_TRIP_SUCCESS = 'redux-frontend/customize/REQUEST_CUSTOMIZE_TRIP_SUCCESS';
var REQUEST_CUSTOMIZE_TRIP_FAIL = 'redux-frontend/customize/REQUEST_CUSTOMIZE_TRIP_FAIL';
var OPEN_CUSTOMIZE_TRIP_POPUP = 'redux-frontend/customize/OPEN_CUSTOMIZE_TRIP_POPUP';
var OPEN_EVENING = 'redux-frontend/customize/OPEN_EVENING';
// const INCREMENT_SEARCH_PAGE_COUNT = 'redux-frontend/customize/INCREMENT_SEARCH_PAGE_COUNT';

var SUBMIT = 'redux-frontend/customize/SUBMIT';
var SUBMIT_SUCCESS = 'redux-frontend/customize/SUBMIT_SUCCESS';
var SUBMIT_FAIL = 'redux-frontend/customize/SUBMIT_FAIL';

var SET_FIELD = 'redux-frontend/customize/SET_FIELD';

var GET_CUSTOMIZE_TRIPS = 'redux-frontend/customize/GET_CUSTOMIZE_TRIPS';
var GET_CUSTOMIZE_TRIPS_SUCCESS = 'redux-frontend/customize/GET_CUSTOMIZE_TRIPS_SUCCESS';
var GET_CUSTOMIZE_TRIPS_FAIL = 'redux-frontend/customize/GET_CUSTOMIZE_TRIPS_FAIL';

var GET_DISPLAY_TRIPS = 'redux-frontend/customize/GET_DISPLAY_TRIPS';

var CUSTOMIZE_QTY = 'redux-frontend/customize/CUSTOMIZE_QTY';
var CUSTOMIZE_QTY_SUCCESS = 'redux-frontend/customize/CUSTOMIZE_QTY_SUCCESS';
var CUSTOMIZE_QTY_FAIL = 'redux-frontend/customize/CUSTOMIZE_QTY_FAIL';

var initialState = {
  searchPageCount: 0,
  submitting: false,
  openCustomizeTripPopup: false,
  isOpenEvening: false,
  submitted: false,
  // submitted: true,
  trips: [],
  displayTrips: [],
  formData: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    // case INCREMENT_SEARCH_PAGE_COUNT:
    //   return {
    //     ...state,
    //     searchPageCount: state.searchPageCount + 1,
    //   };
    case OPEN_CUSTOMIZE_TRIP_POPUP:
      return (0, _extends4.default)({}, state, {
        openCustomizeTripPopup: action.open
      });
    case OPEN_EVENING:
      return (0, _extends4.default)({}, state, {
        isOpenEvening: action.open
      });
    case SUBMIT:
      return (0, _extends4.default)({}, state, {
        submitting: true
      });
    case SUBMIT_SUCCESS:
      return (0, _extends4.default)({}, state, {
        submitting: false,
        submitted: true,
        displayTrips: action.result.trips
      });
    case SUBMIT_FAIL:
      return (0, _extends4.default)({}, state, {
        submitting: false
      });
    case GET_CUSTOMIZE_TRIPS_SUCCESS:
      return (0, _extends4.default)({}, state, {
        trips: action.result
      });
    case GET_DISPLAY_TRIPS:
      return (0, _extends4.default)({}, state, {
        displayTrips: action.data
      });
    case SET_FIELD:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.name, action.value));
    default:
      return state;
  }
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, REQUEST_CUSTOMIZE_TRIP_SUCCESS, function (action) {
  return { name: 'Open Customize Trip', category: 'Customize', source: action.source, tripId: action.tripId };
}), (0, _defineProperty3.default)(_analytics, OPEN_CUSTOMIZE_TRIP_POPUP, function (action) {
  return action.open ? { name: 'Open Customize Trip Popup', category: 'Customize' } : { name: 'Close Customize Trip Popup', category: 'Customize' };
}), (0, _defineProperty3.default)(_analytics, SUBMIT_SUCCESS, function (action) {
  return { name: 'Submit Customize Trip', category: 'Customize', requestData: action.data };
}), _analytics);

// export function incrementSearchPageCount() {
//   return {
//     type: INCREMENT_SEARCH_PAGE_COUNT,
//   };
// }

function openCustomizeTripPopup() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_CUSTOMIZE_TRIP_POPUP,
    open: open
  };
}

function openEvening() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_EVENING,
    open: open
  };
}

function setField(name, value) {
  return {
    type: SET_FIELD,
    name: name,
    value: value
  };
}

function logCustomizeTrip() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tripId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    types: [REQUEST_CUSTOMIZE_TRIP, REQUEST_CUSTOMIZE_TRIP_SUCCESS, REQUEST_CUSTOMIZE_TRIP_FAIL],
    source: source,
    tripId: tripId,
    promise: function promise(client) {
      return client.post('/customize/request', { data: { trip_id: tripId } });
    }
  };
}

function submit(data) {
  return {
    types: [SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/customize', { data: data });
    },
    data: data
  };
}

function getCustomizeTrips() {
  return {
    types: [GET_CUSTOMIZE_TRIPS, GET_CUSTOMIZE_TRIPS_SUCCESS, GET_CUSTOMIZE_TRIPS_FAIL],
    promise: function promise(client) {
      return client.get('/trips/tags?tags=en_today,en_floating_market,en_cooking,en_boating,en_city_tour,en_waterfall,en_cycling,en_beach');
    }
  };
}

function getDisplayTrips(trips, keys) {
  var data = _lodash2.default.slice(_lodash2.default.shuffle([].concat.apply([], _lodash2.default.valuesIn(_lodash2.default.pick(trips, keys)))), 0, 3);
  return {
    type: GET_DISPLAY_TRIPS,
    data: data
  };
}

function customizeQty(data) {
  return {
    types: [CUSTOMIZE_QTY, CUSTOMIZE_QTY_SUCCESS, CUSTOMIZE_QTY_FAIL],
    promise: function promise(client) {
      return client.post('/customize/quantity', { data: data });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/customize.js
// module id = 64
// module chunks = 47